/**
 * Central place for “strong” copy-wizard name checks so they stay aligned with the main editors.
 *
 * **Message flows:** keep in sync with `err.name` validators in `component/messages/mutable.ts` (constructor).
 * **Synchronization templates:** keep in sync with `errName` validators in `component/export-template/mutable.ts`.
 * **Rulesets:** keep in sync with `errName` validators in `component/ruleset/mutable/mutableRuleset.ts`.
 */
export function isCopyWizardNameValid(trimmedName: string): boolean {
    if (!trimmedName) {
        return false;
    }
    if (/[<>]/gm.test(trimmedName)) {
        return false;
    }
    return true;
}

export const isMessageFlowNameValidForCopyWizard = isCopyWizardNameValid;
export const isSyncTemplateNameValidForCopyWizard = isCopyWizardNameValid;
export const isRulesetNameValidForCopyWizard = isCopyWizardNameValid;
